export default __webpack_public_path__ + "static/layout-do-63be3febc321888bd98a960d538f35a8dc52ab7091a37206cfc018c66f135cea.png";